const config = {
  getApiUrl: () => {
    let apiUrl = '/api';
    if (process.env.NODE_ENV == 'production') {
      apiUrl = 'https://forms.biz24.online/api';
    }
    return apiUrl;
  }
};
export default config



// WEBPACK FOOTER //
// ./config.js